import Swiper from "swiper";
import { A11y, Keyboard, Scrollbar } from "swiper/modules";
import "swiper/css";
import "swiper/css/scrollbar";

document.addEventListener("DOMContentLoaded", () => {
	document.querySelectorAll(".heroes_slider-layout").forEach((layout) => {
		const slider = layout.querySelector(".swiper");
		if (!slider) return;

		const count = slider.querySelectorAll(".swiper-slide").length;

		new Swiper(slider, {
			modules: [A11y, Keyboard, Scrollbar],
			slidesPerView: "auto",
			spaceBetween: 16,
			centeredSlides: true,
			initialSlide: Math.max(0, Math.min(2, Math.floor((count - 1) / 2))),
			grabCursor: true,
			watchOverflow: true,
			keyboard: { enabled: true, onlyInViewport: true },
			scrollbar: { el: layout.querySelector(".heroes-slider-scrollbar"), draggable: true },
		});
	});
});
